import phone from "./phone.js";

export default [phone];
